import React from "react";

const Error = props => <div className="error">{props.children}</div>;

export default Error;
